// import React, { useState } from 'react';
// import './SearchInput.css'

// const SearchInput = () => {
//   const [isRotated, setIsRotated] = useState(false);

//   const handleSearchClick = () => {
//     setIsRotated(!isRotated);
//   };
  

//   const inputClassName = isRotated ? 'rotate-input rotate' : 'rotate-input';
//   return (
//     <div>
//       <input type="text" className={inputClassName} placeholder="Search..." />
//       <span className="search-icon" onClick={handleSearchClick}>
//         &#128269;
//       </span>
//     </div>
//   );
// };

// export default SearchInput;
import React, { useState, useEffect, useRef } from 'react';
import './SearchInput.css';
import SearchIcon from '@mui/icons-material/Search';
import {useNavigate} from 'react-router-dom'


const SearchInput = () => {
  const [isRotated, setIsRotated] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    const queryParams = new URLSearchParams({ s: searchQuery });
    navigate(`${queryParams.toString()}`);
  };

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearchClick = () => {
    setIsRotated(!isRotated);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsRotated(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const inputClassName = isRotated ? 'rotate-input' : 'search_ip';

  return (
    <div ref={searchRef} className="search_container">
      <input   placeholder="Search.." 
        type="text"
        className={inputClassName}
        value={searchQuery}
        onChange={handleInputChange}
        onKeyUp={(event)=>{
            if(event.key==='Enter'){
                handleKeyPress(event);
            }
        }} />
      <span className="search-icon" onClick={handleSearchClick}>
        <SearchIcon className="search_icon"/>
      </span>
    </div>
  );
};

export default SearchInput;
